var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "div",
        {
          staticClass: "toast w-100 language-toast hidden mb-3",
          attrs: {
            role: "alert",
            "aria-live": "assertive",
            "aria-atomic": "true",
            "data-autohide": "false",
          },
        },
        [
          _c("div", { staticClass: "toast-body bg-white p-20" }, [
            _c(
              "button",
              {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  type: "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close",
                },
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
            _vm._v(" "),
            _c("p", { attrs: { id: "locale_text" } }),
            _vm._v(" "),
            _c("p", { staticClass: "no-margin" }, [
              _c("button", {
                staticClass: "btn btn-light",
                attrs: { id: "locale_btn_yes" },
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn-light",
                attrs: { id: "locale_btn_no", "data-dismiss": "toast" },
              }),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }